<template>
  <div id="resource-library-app">
    <div class="modal" :class="{ 'is-active': modalOpen }">
      <div class="modal-background"></div>
      <div class="modal-card" v-if="modalItem">
        <section class="modal-card-body">
          <div class="modal-card-body-header">
            <a
              class="delete is-radiusless	"
              aria-label="close"
              @click="modalOpen = false"
            ></a>
          </div>

          <div class="columns">
            <div class="column">
              <div class="is-resource-type pt-2 pb-2">
                <span
                  v-if="
                    modalItem.taxonomies &&
                      modalItem.taxonomies.resource_format &&
                      modalItem.taxonomies.resource_format[0]
                  "
                >
                  {{ modalItem.taxonomies.resource_format[0] }}</span
                >
                <span v-else>&nbsp;</span>
              </div>
              <img
                v-if="
                  modalItem.image &&
                    modalItem.image.sizes &&
                    modalItem.image.sizes.widget
                "
                :src="modalItem.image.sizes.widget"
                alt=""
              />
              <figure v-else>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  viewBox="0 0 500 380"
                >
                  <rect fill="#ddd" width="500" height="380" />
                </svg>
              </figure>
              <div class="mt-2" v-if="modalItem.resource_link">
                <a
                  class="black-button"
                  :href="modalItem.resource_link"
                  target="_blank"
                  style="width: 100%;display: block;text-align: center;"
                >
                  Go to Resource
                </a>
              </div>
              <div class="mt-2" v-if="modalItem.media_library_file">
                <a
                  class="black-button"
                  :href="modalItem.media_library_file"
                  target="_blank"
                  style="width: 100%;display: block;text-align: center;"
                >
                  Go to Resource
                </a>
              </div>
            </div>
            <div class="column">
              <div class="is-title pb-4">
                {{ modalItem.post_title }}
              </div>
              <div class="is-author pb-5">
                {{ modalItem.resource_author }}
              </div>
              <div class="is-content">
                {{ modalItem.content }}
              </div>
              <div class="is-footer"></div>
            </div>
            <div class="column is-1">
              <div class="social-shares">
                <ShareNetwork
                  network="facebook"
                  :url="modalItem.resource_link"
                  :title="modalItem.post_title"
                  :description="modalItem.content"
                >
                  <i class="fab fa-facebook-square fa-2x"></i>
                </ShareNetwork>
                <ShareNetwork
                  network="twitter"
                  :url="modalItem.resource_link"
                  :title="modalItem.post_title"
                >
                  <i class="fab fa-twitter-square fa-2x"></i>
                </ShareNetwork>
                <ShareNetwork
                  network="email"
                  :url="modalItem.resource_link"
                  :title="modalItem.post_title"
                  :description="modalItem.content"
                >
                  <i class="fas fa-envelope-square fa-2x"></i>
                </ShareNetwork>
                <ShareNetwork
                  network="linkedin"
                  :url="modalItem.resource_link"
                  :title="modalItem.post_title"
                >
                  <i class="fab fa-linkedin fa-2x"></i>
                </ShareNetwork>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <ais-instant-search
      :search-client="searchClient"
      index-name="wp_posts_resources"
    >
      <ais-configure :query="query" />

      <div class="columns">
        <div class="column">
          <ais-search-box autofocus show-loading-indicator>
            <div slot-scope="{ isSearchStalled, refine }">
              <div class="field has-addons stylized-input mt-5">
                <div class="control has-icons-left  is-expanded">
                  <input
                    class="input is-radiusless"
                    type="text"
                    v-model="currentRefinement"
                    placeholder="search all resources here"
                    @input="refine($event.currentTarget.value)"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
                <div class="control">
                  <a
                    class="black-button"
                    @click="
                      refine();
                      clearCurrentReginement();
                    "
                  >
                    X
                  </a>
                </div>
              </div>
              <span :hidden="!isSearchStalled">Loading...</span>
            </div>
          </ais-search-box>
        </div>
      </div>
      <div class="columns">
        <div class="column is-one-third ">
          <h3 class="filter-header">
            <span>filter</span>
            <ais-clear-refinements class="clear">
              <div
                class="clear-refinements"
                slot-scope="{ canRefine, refine, createURL }"
              >
                <a :href="createURL()" @click.prevent="refine" v-if="canRefine">
                  clear all
                </a>
              </div>
            </ais-clear-refinements>
          </h3>
          <div ref="collapsibles" id="accordion_first">
            <a
              href="#collapsible-taxonomies-1"
              data-action="collapse"
              class="is-active"
            >
              <h2>Audience</h2>
            </a>
            <div
              id="collapsible-taxonomies-1"
              class="is-collapsible is-active"
              data-parent="accordion_first"
            >
              <ais-refinement-list
                attribute="taxonomies.audience"
                :class-names="{
                  'ais-RefinementList-count': 'tag'
                }"
                :sort-by="['name:asc']"
              />
            </div>
            <a href="#collapsible-taxonomies-2" data-action="collapse">
              <h2>Grade Level</h2>
            </a>
            <div
              id="collapsible-taxonomies-2"
              class="is-collapsible"
              data-parent="accordion_first"
            >
              <ais-refinement-list
                attribute="taxonomies.grade_level"
                :class-names="{
                  'ais-RefinementList-count': 'is-hidden'
                }"
                :sort-by="['name:asc']"
              />
            </div>
            <a href="#collapsible-taxonomies-3" data-action="collapse">
              <h2>Topic Area</h2>
            </a>
            <div
              id="collapsible-taxonomies-3"
              class="is-collapsible"
              data-parent="accordion_first"
            >
              <ais-refinement-list
                attribute="taxonomies.topic_areas"
                :class-names="{
                  'ais-RefinementList-count': 'is-hidden'
                }"
                :sort-by="['name:asc']"
              />
            </div>
            <a href="#collapsible-taxonomies-4" data-action="collapse">
              <h2>Disability Category</h2>
            </a>
            <div
              id="collapsible-taxonomies-4"
              class="is-collapsible"
              data-parent="accordion_first"
            >
              <ais-refinement-list
                attribute="taxonomies.disability"
                :class-names="{
                  'ais-RefinementList-count': 'is-hidden'
                }"
                :sort-by="['name:asc']"
              />
            </div>

            <a href="#collapsible-taxonomies-5" data-action="collapse">
              <h2>Resource Type</h2>
            </a>
            <div
              id="collapsible-taxonomies-5"
              class="is-collapsible"
              data-parent="accordion_first"
            >
              <ais-refinement-list
                attribute="taxonomies.resource_format"
                :class-names="{
                  'ais-RefinementList-count': 'is-hidden'
                }"
                :sort-by="['name:asc']"
              />
            </div>
            <a href="#collapsible-taxonomies-6" data-action="collapse">
              <h2>Themes</h2>
            </a>
            <div
              id="collapsible-taxonomies-6"
              class="is-collapsible"
              data-parent="accordion_first"
            >
              <ais-refinement-list
                attribute="taxonomies.themes"
                :class-names="{
                  'ais-RefinementList-count': 'is-hidden'
                }"
                :sort-by="['name:asc']"
              />
            </div>
            <ais-configure :hitsPerPage="12" />
          </div>
        </div>
        <div class="column">
          <div>
            <ais-current-refinements>
              <template slot="item" slot-scope="{ item, refine, createURL }">
                <span>
                  {{ item.label }}
                  <a
                    class="delete is-small is-radiusless"
                    :href="createURL(item.value)"
                    @click.prevent="refine(item.value)"
                  >
                    X
                  </a>
                </span>
              </template>
            </ais-current-refinements>
          </div>
          <div>
            <ais-hits
              :class-names="{
                'ais-Hits': 'grid-results',
                'ais-Hits-list': 'columns is-multiline',
                'ais-Hits-item':
                  'column is-half-tablet is-one-third-desktop resource_item is-flex'
              }"
            >
              <div class="item-card" slot="item" slot-scope="{ item }">
                <div class="item-header pb-1 pt-1">
                  <span
                    v-if="
                      item.taxonomies.resource_format &&
                        item.taxonomies.resource_format[0]
                    "
                    >{{ item.taxonomies.resource_format[0] }}</span
                  >
                  <span v-else>&nbsp;</span>
                </div>
                <div class="item-content pb-5">
                  <div v-on:click="openModal(item)">
                    <img
                      v-if="
                        item.image &&
                          item.image.sizes &&
                          item.image.sizes.widget
                      "
                      :src="item.image.sizes.widget"
                      alt=""
                    />
                    <figure v-else>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="100%"
                        viewBox="0 0 500 380"
                      >
                        <rect fill="#ddd" width="500" height="380" />
                      </svg>
                    </figure>
                  </div>
                  <div
                    v-on:click="openModal(item)"
                    class="mt-3 pr-3 pl-3 is-title clickable"
                  >
                    {{ item.post_title }}
                  </div>
                  <div class="mt-6 pr-3 pl-3 pb-6 is-author">
                    {{ item.resource_author }}
                  </div>
                </div>
                <div class="item-footer pl-3 pr-3 pt-2 pb-3">
                  <hr />
                  <div class="columns is-mobile">
                    <div
                      class="column has-text-left clickable"
                      v-on:click="openModal(item)"
                    >
                      <i class="fas fa-eye"></i>
                    </div>

                    <div
                      class="column has-text-right clickable"
                      v-on:click="openModal(item)"
                    >
                      <i class="fas fa-share-alt"></i>
                    </div>
                  </div>
                </div>
              </div>
            </ais-hits>
          </div>
          <ais-pagination
            role="navigation"
            aria-label="pagination"
            :class-names="{
              'ais-Pagination': 'pagination is-centered mt-5',
              'ais-Pagination-list': 'pagination-list',
              'ais-Pagination-item--selected': 'is-current',
              'ais-Pagination-link': 'pagination-link'
            }"
          />
        </div>
      </div>
    </ais-instant-search>
  </div>
</template>

<script>
import algoliasearch from "algoliasearch/lite";
import bulmaCollapsible from "../node_modules/@creativebulma/bulma-collapsible/dist/js/bulma-collapsible.min";
// import "instantsearch.css/themes/algolia-min.css";

export default {
  data() {
    return {
      query: "",
      disjunctiveFacetsRefinements: {},
      currentRefinement: null,
      modalOpen: false,
      modalItem: false,
      activateSharingPopup: false,
      searchClient: algoliasearch(
        "V5L2K2OO6N",
        "1b89df8f99a9ca35920218e6ab025ef4"
      )
    };
  },
  methods: {
    openModal(item) {
      console.log("item", item);
      this.modalItem = item;
      this.modalOpen = true;
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    clearCurrentReginement() {
      this.currentRefinement = "";
    }
  },

  mounted() {
    bulmaCollapsible.attach();
    let themeQuery = this.getQueryVariable("theme");
    let stringQuery = this.getQueryVariable("query");
    console.log("stringQuery", stringQuery);
    if (stringQuery) {
      setTimeout(() => {
        this.query = decodeURIComponent(stringQuery.replace(/\+/g, " "));
        this.currentRefinement = this.query;
      }, 1500);
    }

    if (themeQuery) {
      let theme = decodeURIComponent(themeQuery.replace(/\+/g, " "));
      setTimeout(() => {
        var chks = document.querySelectorAll(
          `input[type='checkbox'][value='${theme}']`
        );
        if (chks.length) {
          chks[0].click();
        }
      }, 1500);
    }
  }
};
</script>

<style lang="scss">
#resource-library-app {
  .clickable {
    cursor: pointer;
  }
  .modal-card-body-header {
    display: inline-block;
    width: 100%;
    height: 20px;
    .delete {
      background-color: #323232;
      float: right;
      height: 28px;
      width: 28px;
      min-width: 28px;
      min-height: 28px;
    }
  }
  .modal-card-body {
    position: relative;
    .is-resource-type {
      background: #e3e3e3;
      font-size: 14px;
      // line-height: 19px;
      text-align: center;
      font-weight: normal;
      font-family: "Ubuntu", sans-serif;
      letter-spacing: 0px;
      color: #323232;
      text-transform: capitalize;
    }
    .is-title {
      font-size: 20px;
      line-height: 22px;
      font-weight: bold;
      font-family: "Lato", sans-serif;
      color: #323232;
    }
    .is-author {
      font-size: 13px;
      line-height: 14px;
      font-weight: normal;
      font-family: "Lato", sans-serif;
      color: #323232;
    }
    .is-content {
      font-size: 16px;
      line-height: 20px;
      font-weight: normal;
      font-family: "Lato", sans-serif;
      color: #323232;
    }
    .is-footer {
      padding-bottom: 10px;
    }
  }
  .filter-header {
    padding-bottom: 15px;
    border-bottom: 1px solid #323232;

    span {
      font-weight: bold;
      font-size: 18px;
      line-height: 21px;
      font-family: "Ubuntu", sans-serif;
      letter-spacing: 0.9px;
      color: #323232;
      text-transform: uppercase;
      opacity: 1;
    }
    .clear {
      float: right;
      border-bottom: 1px solid #323232;
      // text-decoration: underline;
      font-weight: bold;
      font-size: 11px;
      line-height: 14px;
      font-family: "Lato", sans-serif;
      letter-spacing: 0px;
      text-transform: uppercase;
      a {
        color: #323232;
      }
    }
  }
  .grid-results {
    .resource_item {
      .item-card {
        box-shadow: 1px 1px 5px #d0d0d0;
        position: relative;
      }
      .item-header {
        background: #8fe3d9 0% 0% no-repeat padding-box;
        opacity: 1;
        text-align: center;
        font-weight: 700;
        font-size: 14px;
        font-family: "Ubuntu", sans-serif;
        color: #323232;
        text-transform: capitalize;
        opacity: 1;
      }
      .item-content {
        text-align: left;

        font-family: "Lato", sans-serif;
        letter-spacing: 0px;
        color: #323232;
        .is-title {
          font-weight: 700;
          font-size: 15px;
          line-height: 18px;
        }
        .is-author {
          font-size: 12px;
          line-height: 14px;
        }
      }
      .item-footer {
        width: 100%;
        position: absolute;
        bottom: 0;
        align-items: stretch;
        // display: flex;
        hr {
          background-color: #707070;
          height: 1px;
          margin: 0 0 5px;
        }
      }
    }
  }
  #accordion_first {
    a {
      display: block;
      box-shadow: 1px 1px 5px #d0d0d0;
      padding: 12px 20px;
      margin-top: 20px;
      font-weight: bold;
      font-size: 15px;
      line-height: 17px;
      font-family: "Ubuntu", sans-serif;
      letter-spacing: 0.75px;
      color: #323232;
      text-transform: uppercase;
      opacity: 1;
    }
    div.is-collapsible.is-active {
      box-shadow: 0px 3px 6px #d0d0d0;
      padding: 25px 20px;
      height: 100% !important;

      .ais-RefinementList-labelText {
        font-weight: normal;
        font-size: 18px;
        line-height: 23px;
        font-family: "Lato", sans-serif;
        letter-spacing: 0px;
        color: #323232;
      }
    }
  }
  .social-shares {
    margin-top: 60px;
    // position: absolute;
    // bottom: 0;
    a {
      display: block;
      margin-bottom: 10px;
      color: #2055b5;
    }
  }
  .stylized-input {
    input.input {
      background: #ffffff 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #d0d0d0;
      border: 2px solid #707070;
      font: normal normal bold 16px/18px "Ubuntu";
      letter-spacing: 0.65px;
      color: #707070;
      text-transform: uppercase;
    }

    .black-button {
      padding: 11px 20px 12px;
      border-left: none;
      display: inline-block;
    }
  }
  .black-button {
    background: #323232 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #d0d0d0;
    padding: 10px 20px;
    font: normal normal bold 15px/17px "Ubuntu";
    letter-spacing: 0.75px;
    color: #ffffff;
    text-transform: uppercase;

    &:hover {
      color: #ffffff;
    }
  }
  .pagination a,
  .page-numbers {
    padding-bottom: calc(0.5em - 1px);
    // padding-left: calc(.75em - 1px);
    // padding-right: calc(.75em - 1px);
    padding-top: calc(0.5em - 1px);
  }
  // Algolia
  .ais-Pagination-item.ais-Pagination-item--selected.is-current a {
    background-color: #8fe3d9;
  }
  .ais-CurrentRefinements-list {
    margin-bottom: 20px;
    li {
      display: inline;
      margin-right: 1em;
    }
    li span {
      background: #ffffff 0% 0% no-repeat padding-box;
      box-shadow: 1px 1px 5px #d0d0d0;
      border: 1px solid #707070;
      padding: 5px 5px 5px 10px;
      font-weight: 600;
      font-size: 18px;
      line-height: 23px;
      font-family: "Lato";
      letter-spacing: 0px;
      color: #323232;
      display: inline;
      .delete {
        vertical-align: middle;
        background-color: #323232;
        margin-left: 5px;
        margin-bottom: 4px;
        margin-right: 3px;
      }
    }
  }
}
</style>
